import { API_HOST_NAME, API_SP_POLICY_PATH } from '../../env.js';
import request, {
  GET_REQUEST,
  POST_FORM_DATA_REQUEST,
  POST_REQUEST,
} from '@helpers/request.js';
import { getCookie } from '@helpers/cookie.js';
import { TOKEN } from '@helpers/constants/index.js';
import axios from 'axios';

const POLICY_ROOT = API_HOST_NAME + API_SP_POLICY_PATH;
export const structurePaths = {
  policyInquiry: {
    getPhone: POLICY_ROOT + '/policyInquiry/get-phone',
    getPOFullName: POLICY_ROOT + '/policyInquiry/get-po-full-name',
    searchPolicy: POLICY_ROOT + '/search/',
    uwDownloadDocument: POLICY_ROOT + '/uw-letter/download',
    searchInquiryPolicies: POLICY_ROOT + '/policyInquiry/search',
    getPolicyProvinceList: POLICY_ROOT + '/provinces/get-from-ing',
    getAllPendingDocumentTypes:
      API_HOST_NAME + '/upload/getAllPendingDocumentTypes',
    uploadFileTemps: API_HOST_NAME + '/document/uploadFile',
    removeFileTemps: API_HOST_NAME + '/document/removeFile',
    submitUploadFile: API_HOST_NAME + '/upload/submit',
    exportPremium: POLICY_ROOT + '/export-premium',
    getCrmLovList: POLICY_ROOT + '/get/crmLovList',
    getMainLaFullName: POLICY_ROOT + '/policyInquiry/main-la-full-name',
    getListOfValue: API_HOST_NAME + '/e-recruitment/get-list-of-value',
    searchDocumentByTypeAndName: POLICY_ROOT + '/searchDocumentByTypeAndName',
    downloadEContractAndECer: POLICY_ROOT + '/downloadEContractAndECer',
    findPolicyRefferal: API_HOST_NAME + '/data/policy-referral/find-by',
    filterAcbLbsAgent:
      API_HOST_NAME + '/data/policy-referral/filter-acb-lbs-agent',
    filterAcbTeam: API_HOST_NAME + '/data/policy-referral/filter-acb-team',
    adjustAcbRefferal: API_HOST_NAME + '/data/policy-referral/save-adjustment',
    getLinkQrCodeForPremiumDuePolicy:
      POLICY_ROOT + '/premium-due/get-link-qr-code',
    getPolicyDetail: API_HOST_NAME + '/policy/policyInquiry/details',
    getEcontractAndECer: POLICY_ROOT + '/getEcontractAndECer',
    getPOSRequestLovs: POLICY_ROOT + '/pos-request-lovs',
    getTransferHistory:
      API_HOST_NAME + '/sales-portal/policies/get-transfer-history',
    getPolicyDetailAdditionalContent:
      API_HOST_NAME + '/policy/pending/get-policy-detail-additional-content',
  },
};

export const getPhoneService = (data) => {
  return POST_FORM_DATA_REQUEST(structurePaths.policyInquiry.getPhone, data);
};

export const getPOFullNameService = (data) => {
  return POST_FORM_DATA_REQUEST(
    structurePaths.policyInquiry.getPOFullName,
    data,
  );
};

export const searchPolicyService = ({ status, data }) => {
  return GET_REQUEST(structurePaths.policyInquiry.searchPolicy + status, data);
};

export const getPoliciesOnSearchService = (
  polId,
  appNo,
  locationCode,
  policyOwnerName,
  insuredName,
  page,
  size,
) => {
  const data = {
    size,
    page,
  };

  if (locationCode) data.locationCode = locationCode;
  if (policyOwnerName) data.poName = policyOwnerName;
  if (appNo) data.appNo = appNo;
  if (polId) data.poId = polId;
  if (insuredName) data.insuredName = insuredName;

  return POST_FORM_DATA_REQUEST(
    structurePaths.policyInquiry.searchInquiryPolicies,
    data,
  );
};

export const getPolicyProvinceListService = () => {
  return GET_REQUEST(structurePaths.policyInquiry.getPolicyProvinceList, {});
};

export const getAllPendingDocumentTypes = () => {
  return GET_REQUEST(
    structurePaths.policyInquiry.getAllPendingDocumentTypes,
    {},
  );
};

export const uploadFileFolderTemps = ({ data }) => {
  return POST_FORM_DATA_REQUEST(
    structurePaths.policyInquiry.uploadFileTemps,
    data,
  );
};

export const removeFileFolderTemps = ({ data }) => {
  return POST_FORM_DATA_REQUEST(
    structurePaths.policyInquiry.removeFileTemps,
    data,
  );
};

export const submitUploadFile = ({ data }) => {
  return POST_FORM_DATA_REQUEST(
    structurePaths.policyInquiry.submitUploadFile,
    data,
  );
};

export const exportPremiumDueService = (status, data) => {
  let endPoint = '';
  if (status === 'premiumDue') {
    endPoint = '-due-excel';
  } else {
    endPoint = '-holiday-policy';
  }
  return GET_REQUEST(
    structurePaths.policyInquiry.exportPremium + endPoint,
    data,
  );
};

export const getCrmLovListService = ({ data }) => {
  return GET_REQUEST(structurePaths.policyInquiry.getCrmLovList, data);
};

export const getMainLaFullNameService = (policyId) => {
  return GET_REQUEST(structurePaths.policyInquiry.getMainLaFullName, {
    policyId,
  });
};

export const getListOfValuesClaimDocumentService = () => {
  const lovTypes = ['CLM_DOC_TYP', 'CLM_DOC_NM'];

  return GET_REQUEST(structurePaths.policyInquiry.getListOfValue, {
    lovTypes: lovTypes.join(','),
  });
};

export const searchDocumentByTypeAndNameService = (
  policyId,
  documentType,
  documentName,
) => {
  return GET_REQUEST(structurePaths.policyInquiry.searchDocumentByTypeAndName, {
    policyId,
    documentType,
    documentName,
  });
};

export const getEcontractAndECer = () =>
  request(structurePaths.policyInquiry.getEcontractAndECer, {
    method: 'GET',
  });

export const downloadEContractAndECerService = (documentId) => {
  const SPAccessToken = getCookie(TOKEN.SP_ACCESS_TOKEN);
  return axios.get(
    `${structurePaths.policyInquiry.downloadEContractAndECer}?documentId=${documentId}`,
    {
      responseType: 'blob', // this is important!
      headers: {
        Authorization: `Bearer ${SPAccessToken}`,
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
      },
    },
  );
};

export const searchBankEmployeeCodeService = (code) => {
  const params = {
    code,
  };

  return GET_REQUEST(structurePaths.policyInquiry.filterAcbLbsAgent, params);
};

export const searchReferralUnitCodeService = (code) => {
  const params = {
    code,
  };

  return GET_REQUEST(structurePaths.policyInquiry.filterAcbTeam, params);
};

export const getLinkQrCodeForPremiumDuePolicy = (policyId) => {
  return GET_REQUEST(
    structurePaths.policyInquiry.getLinkQrCodeForPremiumDuePolicy,
    {
      polId: policyId,
    },
  );
};

export const getPolicyDetailService = (data) => {
  return POST_FORM_DATA_REQUEST(
    structurePaths.policyInquiry.getPolicyDetail,
    data,
  );
};

export const getPosRequestLovsService = () => {
  return GET_REQUEST(structurePaths.policyInquiry.getPOSRequestLovs);
};

export const getPolicyTransferHistoryService = ({ policyId, page, size }) => {
  return GET_REQUEST(structurePaths.policyInquiry.getTransferHistory, {
    policyId: policyId,
    page: page,
    size: size,
  });
};

export const getPolicyDetailAdditionalContentService = (requestParams) => {
  return GET_REQUEST(
    structurePaths.policyInquiry.getPolicyDetailAdditionalContent,
    requestParams,
  );
};
